import { CustomIconProps } from './art';

export const SkillIcon = (props: CustomIconProps): JSX.Element => (
  <svg width="21" height="21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.555 11.058l4.75-.025.039 7.5-4.75.025-.039-7.5zM7.786 7.338l4.75-.025.058 11.25-4.75.024-.058-11.25zM2.01 2.367l4.75-.024.084 16.25-4.75.024-.084-16.25z"
      fill="#259BE9"
    />
  </svg>
);
